import WarehouseIcon from "@mui/icons-material/Warehouse";

import { registerNavSection } from "./shell/navigation";

registerNavSection({ key: "inventory", spoke: "inventory", title: "Inventory", icon: WarehouseIcon, order: 47, entries: [
  { label: "Dashboard", to: "/app/inventory", permission: "inventory.stock.view" },
  { label: "Stock inquiry", to: "/app/inventory/stock", permission: "inventory.stock.view" },
  { label: "Ledger", to: "/app/inventory/ledger", permission: "inventory.stock.view" },
  { label: "Lots & heats", to: "/app/inventory/lots", permission: "inventory.stock.view" },
  { label: "Warehouse tasks", to: "/app/inventory/tasks", permission: "inventory.task.view" },
  { label: "Mobile queue", to: "/app/inventory/mobile", permission: "inventory.task.execute" },
  { label: "Counts", to: "/app/inventory/counts", permission: "inventory.count.view" },
  { label: "Transfers", to: "/app/inventory/transfers", permission: "inventory.movement.view" },
  { label: "Adjustments", to: "/app/inventory/adjustments", permission: "inventory.movement.view" },
  { label: "Item / warehouse settings", to: "/app/masterdata/item-settings", permission: "inventory.stock.view" },
  { label: "Put-away rules", to: "/app/masterdata/putaway-rules", permission: "inventory.task.view" },
  { label: "Remnants", to: "/app/masterdata/remnants", permission: "inventory.stock.view" },
  { label: "Stock statuses", to: "/app/masterdata/inventory-statuses", permission: "inventory.stock.view" },
] });
